import React, {
  ReactNode,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import {t} from 'lib/i18n';

interface IPlayerTemplateProps {
  info: ReactNode;
  video: ReactNode;
  control: ReactNode;
  screen: ReactNode;
  chat: ReactNode;
  isChat: boolean;
  onClickOpenChat: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const PlayerTemplate: React.FC<IPlayerTemplateProps> = (props) => {
  const playerRef = useRef<HTMLDivElement | null>(null);
  const playerContentsRef = useRef<HTMLDivElement | null>(null);
  const [, setControlBar] = useState(''); // 컨트롤바 css 클래스 상태
  const [displayChat, setDisplayChat] = useState({
    cssClass: 'chat_open',
    width: 1100 - 296, // 1100px 초기값인데 props.isChat useEffect쪽에 렌더링 시 타기 때문에 -296함
  }); // 채팅창 여부

  /**
   * 플레이어 스크린 마우스 움직였을 때 컨트롤바 SHOW
   */
  const onPlayerMouseMove = useCallback(() => {
    if (playerRef.current) {
      setControlBar('mouseover');
    }
  }, [setControlBar]);
  useEffect(() => {
    if (playerRef.current) {
      playerRef.current.addEventListener('mousemove', onPlayerMouseMove);
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.removeEventListener('mousemove', onPlayerMouseMove);
      }
    };
  }, [onPlayerMouseMove]);

  /**
   * 채팅 보이기/숨기기
   */
  useEffect(() => {
    if (props.isChat) {
      if (!playerContentsRef.current) return;

      const width = parseInt(playerContentsRef.current.style.maxWidth as any);
      setDisplayChat({
        width: width + 296,
        cssClass: 'chat_open',
      });
    } else {
      if (!playerContentsRef.current) return;

      const width = parseInt(playerContentsRef.current.style.maxWidth as any);
      setDisplayChat({
        width: width - 296,
        cssClass: '',
      });
    }
  }, [props.isChat]);

  return (
    <div className={`webeditor_player ${displayChat.cssClass}`}>
      <div
        className='webeditor_player_contents'
        ref={playerContentsRef}
        style={{maxWidth: `${displayChat.width}px`}}>
        <div id='player_area'>
          <div
            id='player'
            // className={controlBar}
            className='mouseover'
            ref={playerRef}
            // style={{ height: "500px" }}
          >
            <div className='player_size'></div>
            {/* <div className="watermark opacity">afreecaTV</div> */}
            <div className='default_logo' style={{background: '#'}}>
              SOOP
            </div>
            {props.info}
            {props.video}
            {/* {props.screen} */}
            {props.control}
            {!props.isChat && (
              <ul className='view_ctrl' style={{display: 'flex'}}>
                <li className='btn_chat'>
                  <button type='button' onClick={props.onClickOpenChat}>
                    <span>{t('채팅창 on/off')}</span>
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
        <div id='chat_area'>{props.chat}</div>
      </div>
    </div>
  );
};

export default PlayerTemplate;
